function getInitials(nombre) {
  if (!nombre) return '?';
  const parts = nombre.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || '';
  const second = parts.length > 1 ? parts[1][0] : '';
  return (first + second).toUpperCase() || '?';
}

function Avatar({ nombre, className = 'h-9 w-9' }) {
  return (
    <span
      className={`flex ${className} shrink-0 items-center justify-center rounded-full bg-green-100 text-sm font-semibold text-green-700`}
      aria-hidden="true"
    >
      {getInitials(nombre)}
    </span>
  );
}

export default Avatar;
